import { createSlice } from '@reduxjs/toolkit';

// Helper function to filter out unwanted fields from user data
const filterUserData = (user) => {
  if (!user) return user;
  const { suppliers, customers, ...filteredUser } = user;
  return filteredUser;
};

const initialState = {
  token: localStorage.getItem('token'),
  isAuthenticated: !!localStorage.getItem('token'), // Set to true if token exists
  loading: false,
  user: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null,
  userType: localStorage.getItem('userType') || null,
  error: null
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    loginSuccess: (state, action) => {
      state.loading = false;
      state.isAuthenticated = true;
      state.token = action.payload.token;
      state.user = filterUserData(action.payload.user);
      state.userType = action.payload.userType;
      state.error = null;
      
      // Persist to localStorage
      localStorage.setItem('token', action.payload.token);
      localStorage.setItem('userType', action.payload.userType);
      localStorage.setItem('user', JSON.stringify(filterUserData(action.payload.user)));
    },
    loginFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.isAuthenticated = false;
      state.token = null;
      state.user = null;
      state.userType = null;
      
      // Clear localStorage
      localStorage.removeItem('token');
      localStorage.removeItem('userType');
      localStorage.removeItem('user');
    },
    setUser: (state, action) => {
      state.user = filterUserData(action.payload);
      // Also update localStorage
      localStorage.setItem('user', JSON.stringify(filterUserData(action.payload)));
    },
    tokenRefreshed: (state, action) => {
      const nextToken = action.payload?.token;
      if (!nextToken) return;
      state.token = nextToken;
      state.isAuthenticated = true;
      localStorage.setItem('token', nextToken);
    },
    logout: (state) => {
      state.token = null;
      state.isAuthenticated = false;
      state.loading = false;
      state.user = null;
      state.userType = null;
      state.error = null;
      
      // Clear localStorage
      localStorage.removeItem('token');
      localStorage.removeItem('userType');
      localStorage.removeItem('user');
    },
    clearAllState: () => {
      // This will be handled by the store configuration
      return initialState;
    }
  }
});

export const { 
  loginStart, 
  loginSuccess, 
  loginFailure, 
  setUser,
  tokenRefreshed,
  logout,
  clearAllState
} = authSlice.actions;

export default authSlice.reducer; 